import Lenis from "lenis";

import type { ComponentInit } from "@scripts/registry";
import { getScrollController, setScrollController } from "@scripts/scrollController";
import { isScrollLocked } from "@scripts/scrollLock";

const LERP = 0.12;
const NATIVE = "data-fa-scroll-native";
const ACTIVE = "fa-smooth-scroll";

export const initSmoothScroll: ComponentInit = (root) => {
	if (getScrollController()) return;

	// Set before constructing, or Lenis measures a root the `height: auto` has yet to free.
	document.documentElement.classList.add(ACTIVE);

	const lenis = new Lenis({
		lerp: LERP,
		smoothWheel: true,
		anchors: true,
		autoRaf: true,
		allowNestedScroll: true,
		prevent: (node) => node.hasAttribute(NATIVE),
	});

	setScrollController(
		{
			stop: () => lenis.stop(),
			start: () => lenis.start(),
			scrollTo: (target, offset) => lenis.scrollTo(target, { offset: -offset }),
		},
		root,
	);

	if (isScrollLocked()) lenis.stop();

	return () => {
		setScrollController(undefined);
		document.documentElement.classList.remove(ACTIVE);
		lenis.destroy();
	};
};
